<div class="checkout-header-component outer-container">
  <div class="container">
    <div class="row">
      <div class="col">
        <app-checkout-progress></app-checkout-progress>
      </div>
    </div>
  </div>
</div>
